import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { AppService, ApplicationInsightService, SessionService } from '../../services';
import { UserProperty, AppProperty } from '../../properties';
import { Router } from '@angular/router';
import { AppComponent } from '../../app.component';
import { AppStateHolder } from '../../shared';
import { DebugLoggerService } from '../../services/debug-logger.service';
import { SidebarModule } from 'primeng/sidebar';
import { Button, ButtonDirective } from 'primeng/button';
import { Ripple } from 'primeng/ripple';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'user-menu',
    templateUrl: './user-menu.component.html',
    styleUrls: ['./user-menu.component.css'],
    standalone: true,
    imports: [SidebarModule, Button, Ripple, ButtonDirective, TranslateModule]
})
export class UserMenuComponent implements OnInit {
  userProperty = inject(UserProperty);
  private _appService = inject(AppService);
  appStateHolder = inject(AppStateHolder);
  appProperty = inject(AppProperty);
  sessionService = inject(SessionService);
  private _appInsightsService = inject(ApplicationInsightService);
  private _router = inject(Router);
  appComponent = inject(AppComponent);
  private _debugLogger = inject(DebugLoggerService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() { }

  @Input() visible: boolean = false;
  @Output() close: EventEmitter<boolean> = new EventEmitter();


  canManageAccountSettings: boolean = false;

  ngOnInit(): void {
    this.canManageAccountSettings = this.appStateHolder.getCookie('authType') != 'b2c';
  }

  changePassword() {
    this._debugLogger.logAction('UserMenu', 'changePassword');
    this._debugLogger.logNavigation('/app/password-1');
    this._router.navigate(['/app', 'password-1']);
  }

  signOut(): void {
    this._debugLogger.logAction('UserMenu', 'signOut');
    this.closeSidebar();
    this._appInsightsService.clearUserId();
    this.appStateHolder.signOut();
  }

  navigateToAccountSettings() {
    this._debugLogger.logNavigation('/accountSettings');
    this.closeSidebar();
    this._router.navigate(['/accountSettings']);
  }


  closeSidebar() {
    this.close.emit(true);
  }
}
